import React from "react";
import { useRoutes, Navigate } from "react-router-dom";
import NotFound from "pages/NotFound";
import WebDesign from "pages/WebDesign";
import BetaRedirect from "pages/BetaRedirect";
import Competitions from "pages/Competitions";
import ArianaGrande from "pages/ArianaGrande";
import NewHome from "newSite/Home";
import NewLayout from "newSite/Layout";
import AllCompetitions from "newSite/AllCompetitions";
import CompetitionDetail from "newSite/CompetitionDetail";
import Terms from "newSite/Terms";
import Privacy from "newSite/Privacy";

const ProjectRoutes = () => {
  let element = useRoutes([
    {
      path: "/",
      element: <NewLayout />,
      children: [
        { index: true, element: <NewHome /> },
        { path: "competitions", element: <AllCompetitions /> },
        { path: "competitions/:id", element: <CompetitionDetail /> },
        { path: "terms", element: <Terms /> },
        { path: "privacy", element: <Privacy /> }
      ]
    },
    { path: "*", element: <NotFound /> },
    
    // Legacy routes - can be removed or redirected later
    { path: "/old", element: <WebDesign /> },
    { path: "/termsconditions", element: <Terms /> },
    { path: "/privacypolicy", element: <Privacy /> },
    { path: "/beta", element: <BetaRedirect /> },
    { path: "/Competitions", element: <Competitions /> },
    { path: "/arianagrande", element: <Navigate to="/competitions/1" replace /> },
    
    // Redirect old newsite path to root
    { path: "/newsite/*", element: <Navigate to="/" replace /> }
  ]);

  return element;
};

export default ProjectRoutes;
